import config from '@/config';
import { fetchWithKeycloakToken } from '@/features/Keycloak/keycloakService';

export type TestNotificationChannel = 'Slack' | 'Email';

// senhub answers in plain text, except ASP.NET's own errors (e.g. 404), which are
// problem-details JSON.
const readMessage = async (response: Response): Promise<string> => {
  const text = await response.text();
  try {
    const parsed: unknown = JSON.parse(text);
    if (typeof parsed === 'string') {
      return parsed;
    }
    if (parsed && typeof parsed === 'object') {
      const { detail, title } = parsed as { detail?: unknown; title?: unknown };
      if (typeof detail === 'string') return detail;
      if (typeof title === 'string') return title;
    }
  } catch {
    // Plain text.
  }
  return text;
};

/**
 * Asks senhub to send one test alert review failure notification through
 * `channel`, using the customer's SAVED config. Resolves with senhub's message;
 * rejects with its reason (e.g. "Slack test failed: ... no_service").
 *
 * Not executeRest: a refused test is an expected answer, shown in the caller's
 * own toast rather than executeRest's generic HTTP error toast.
 */
export async function sendAlertReviewerTestNotification(
  customerId: string,
  channel: TestNotificationChannel,
): Promise<string> {
  const response = await fetchWithKeycloakToken(
    `${config.rest.url}/alert-reviewer/customers/${customerId}/test-notification`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ channel }),
    },
  );

  const message = await readMessage(response);
  if (!response.ok) {
    throw new Error(message || `HTTP error ${response.status}`);
  }
  return message;
}
